<template>
<el-card class="formula-card" v-if="formulaAndService">
  <div class="formula-card__title">
    <font-awesome-icon class="formula-card__title__icon" :icon="['fal', 'truck']"/>
    <span class="bold formula-card__title__label">{{ $t('validate.serviceOffer') }}</span>
  </div>
  <div class="formula-card__body">
    <div class="formula-card__table">
      <next-table display-check :title="formula"
                  :items="formulaAndService.presta" />
    </div>
    <div class="formula-card__table"
         v-if="formulaAndService.services && formulaAndService.services.length > 0">
      <next-table display-check :title="$t('validate.otherServiceOffer')"
                  :items="formulaAndService.services"/>
    </div>
  </div>
</el-card>
</template>

<script>
import NextTable from '@/components/validate/NextTable.vue';

export default {
  name: 'FormulaAndServiceCard',
  components: { NextTable },
  props: {
    formulaAndService: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formula() {
      if (this.formulaAndService.formula === undefined) return '';
      return this.$t('validate.formula.label',
        { formula: this.$t(`validate.formula.${this.formulaAndService.formula}`) });
    },
  },
};
</script>

<style scoped lang="scss">
.formula-card{
  &__title{
    text-transform: uppercase;
    font-size: $--font-size-large;
    display: flex;
    height: 32px;
    margin-bottom: 8px;
    align-items: center;
    &__label{
      padding-left: 8px;
    }
    &__icon {
      height: 32px;
      width: 32px;
    }
  }
  &__body {
    display: inline-block;
    width: 100%;
  }
  &__table{
    margin: 8px;
  }
}
</style>
